import {
    FETCH_TECHNICIAN_LOGS,
    RESET_TECHNICIAN_LOGS,
  } from "../../constants/action.constants";
  
  const initialState = {
    list: [],
    others: {
      total: 0,
      offset: 0,
      limit: 10,
    },
  };
  
  const technicianLogsReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_TECHNICIAN_LOGS:
        return { list: action.payload, others: action.others };
      case RESET_TECHNICIAN_LOGS:
        return initialState;
      default:
        return state;
    }
  };
  
  export default technicianLogsReducer;
  